module.exports = __webpack_public_path__ + "static/backPanel@2x-ab839e32051595ed22d3b83c8acca7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/backPanel@2x.png
// module id = 2596
// module chunks = 168707334958949